<template>
  <f7-page>
    <f7-navbar>
      <f7-nav-left>
        <f7-link icon-if-ios="f7:menu" icon-if-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <f7-nav-title>下載 QR Code</f7-nav-title>
    </f7-navbar>
    <f7-toolbar tabbar scrollable>
      <f7-link
        :tab-link="`#tab-${key + 1}`"
        tab-link-active
        v-for="(item, key) in reverseMenuVariations"
        @click="selectedVariation = item.variation"
        :key="`menuVariation-link-${key}`">
        {{ item.variationTitle }}
      </f7-link>
    </f7-toolbar>
    <f7-tabs npm >
      <f7-tab
        v-for="(item,key) in reverseMenuVariations"
        :key="`menuVariation-${key}`"
        :id="`tab-${key + 1}`"
        class="page-content"
        :class = "{ 'tab-active' : key == 0 }"
        style="padding-top: 20px;"
        >
        <f7-list media-list>
          <f7-list-item :title="`${item.variationTitle} - 現場外帶`" after="下載" @click="download('takeAway')" />
          <f7-list-item :title="`${item.variationTitle} - 預約外帶`" after="下載" @click="download('preOrder')" />
          <f7-list-item
            v-for="(tableNumber, index) in tableNumbers"
            :key="`qr-code-download-table-numbers-${index}`"
            :title="`${item.variationTitle} - 內用 (${tableNumber})`"
            after="下載"
            class="ripple"
            style="overflow: hidden;"
            @click="download('forHere', tableNumber)" />
        </f7-list>
      </f7-tab>
    </f7-tabs>
  </f7-page>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  data () {
    return {
      selectedVariation: 'main'
    }
  },
  async created () {
    await this.setStore(this.storeIdProp)
    this.getTableNumbers()
    await this.getMenuVariations()
  },
  computed: {
    ...mapState(['tableNumbers']),
    ...mapState('menuModule', ['menuVariations']),
    reverseMenuVariations () {
      // 檢查是否有 主要菜單
      let menuVariations = [...this.menuVariations]
      let main = menuVariations.find(item => {
        return item.variation === 'main'
      })
      if (main) {
        let menuVariations = [...this.menuVariations]
        let result = menuVariations.filter(item => {
          return item.variation !== 'main'
        })
        result.unshift(main)
        return result
      } else {
        return menuVariations
      }
    }
  },
  props: {
    storeIdProp: String
  },
  methods: {
    ...mapActions(['setStore', 'getTableNumbers']),
    ...mapActions('menuModule', ['getMenuVariations']),
    download (dp, tn) {
      const obj = { dp, tn }
      const query = Object.keys(obj).reduce((q, k) => obj[k] ? q.concat([encodeURIComponent(k) + '=' + encodeURIComponent(obj[k])]) : q, []).join('&')
      window.open(`${process.env.VUE_APP_URLS_API}/stores/${this.storeIdProp}/menus/qrCodeImages/${this.selectedVariation}${query.length !== 0 ? '?' : ''}${query}`)
    }
  }
}
</script>
